import React, { useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';

const ReportDropdown = ({
  reportRef,
  permissionPdf = false,
  permissionExcel = false,
  onDownloadXlsx = () => {},
  onDownloadXlsxColumns = () => {},
  onDownloadXlsxGeneral = () => {},
  onDownloadCSV = () => {},
  onDownloadXlsxComments = () => {},
}) => {

  const ref = useRef();
  const print = useReactToPrint({
    content: () => reportRef.current,
  });

  const [isOpen, setIsOpen] = useState(false);
  const [downloadTypes, setDownloadTypes] = useState({
    xlsx: false,
    xlsxColumns: false,
    xlsxGeneral: false,
    xlsxComments: false,
    csv: false,
  });

  const onDownlaod = () => {

    if (downloadTypes.pdf)
      print();

    if (downloadTypes.xlsx)
      onDownloadXlsx();
    
    if (downloadTypes.xlsxColumns) 
      onDownloadXlsxColumns();
    
    if (downloadTypes.xlsxGeneral) 
      onDownloadXlsxGeneral();

    if (downloadTypes.xlsxComments)
      onDownloadXlsxComments();
    
    if (downloadTypes.csv) 
      onDownloadCSV();
    

    setIsOpen(false);
    setDownloadTypes({
      xlsx: false,
      xlsxColumns: false,
      xlsxGeneral: false,
      xlsxComments: false,
      csv: false,
    });

  }

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, []);

  return (
    <div ref={ref} className='dropdown'>
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        Descargar reporte
      </button>
      <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`}>

        {permissionPdf && (
          <li>
            <div className="dropdown-item">
              <input
                type='checkbox'
                className='form-check-input me-2'
                checked={downloadTypes.pdf}
                onChange={(e) => {
                  setDownloadTypes({
                    ...downloadTypes,
                    pdf: e.target.checked
                  });
                }}
              />
              <i className="bi bi-file-earmark-pdf me-2 text-danger"></i>
              PDF
            </div>
          </li>
        )}

        {
          permissionExcel && (<>

            <li>
              <div className="dropdown-item" role='button'>
                <input 
                  type='checkbox' 
                  className='form-check-input me-2'
                  checked={downloadTypes.csv}
                  onChange={(e) => {
                    setDownloadTypes({
                      ...downloadTypes,
                      csv: e.target.checked
                    });
                  }}
                />
                <i className="bi bi-filetype-csv text-primary" style={{ marginRight: "7px" }}></i>
                CSV
              </div>
            </li>

            <li>
              <div className="dropdown-item" role='button'>
                <input 
                  type='checkbox' 
                  className='form-check-input me-2'
                  checked={downloadTypes.xlsx}
                  onChange={(e) => {
                    setDownloadTypes({
                      ...downloadTypes,
                      xlsx: e.target.checked
                    });
                  }}
                />
                <i className="bi bi-file-earmark-excel text-success" style={{ marginRight: "7px" }}></i>
                Excel
              </div>
            </li>

            <li>
              <div className="dropdown-item" role='button'>
                <input 
                  type='checkbox' 
                  className='form-check-input me-2'
                  checked={downloadTypes.xlsxColumns}
                  onChange={(e) => {
                    setDownloadTypes({
                      ...downloadTypes,
                      xlsxColumns: e.target.checked
                    });
                  }}
                />
                <i className="bi bi-file-earmark-excel text-success" style={{ marginRight: "7px" }}></i>
                Excel Columnas
              </div>
            </li>

            <li>
              <div className="dropdown-item" role='button'>
                <input 
                  type='checkbox' 
                  className='form-check-input me-2'
                  checked={downloadTypes.xlsxGeneral}
                  onChange={(e) => {
                    setDownloadTypes({
                      ...downloadTypes,
                      xlsxGeneral: e.target.checked
                    });
                  }}
                />
                <i className="bi bi-file-earmark-excel text-success" style={{ marginRight: "7px" }}></i>
                Excel Generalizado
              </div>
            </li>
            
            <li>
              <div className="dropdown-item" role='button'>
                <input 
                  type='checkbox' 
                  className='form-check-input me-2'
                  checked={downloadTypes.xlsxComments}
                  onChange={(e) => {
                    setDownloadTypes({
                      ...downloadTypes,
                      xlsxComments: e.target.checked
                    });
                  }}
                />
                <i className="bi bi-file-earmark-excel text-success" style={{ marginRight: "7px" }}></i>
                Excel Comentarios
              </div>
            </li>
            
          </>)
        }

        <div className="dropdown-divider"></div>

        <li>
          <div className="dropdown-item">
            <button
              className="btn btn-primary"
              onClick={onDownlaod}
              disabled={!Object.values(downloadTypes).some(Boolean)}
            >
              Descargar
            </button>
          </div>
        </li>

      </ul>

    </div>
  );
};


export default ReportDropdown;